<div class="new-reaction-div">
    <p-card class="p-shadow-10 p-d-flex new-reaction-card">
        <span
            (click)="addReaction(reactionTypes[0].id)"
            class="reaction-item"
            pTooltip="{{ 'clubs.page.common.reactions.like' | translate }}"
            tooltipPosition="top"
        >
            {{ reactionTypes[0].code }}
        </span>
        <span
            (click)="addReaction(reactionTypes[1].id)"
            class="reaction-item p-ml-2"
            pTooltip="{{ 'clubs.page.common.reactions.love' | translate }}"
            tooltipPosition="top"
        >
            {{ reactionTypes[1].code }}
        </span>
        <span
            (click)="addReaction(reactionTypes[2].id)"
            class="reaction-item p-ml-2"
            pTooltip="{{ 'clubs.page.common.reactions.laughing' | translate }}"
            tooltipPosition="top"
        >
            {{ reactionTypes[2].code }}
        </span>
        <span
            (click)="addReaction(reactionTypes[5].id)"
            class="reaction-item p-ml-2"
            pTooltip="{{ 'clubs.page.common.reactions.oh' | translate }}"
            tooltipPosition="top"
        >
            {{ reactionTypes[5].code }}
        </span>
        <span
            (click)="addReaction(reactionTypes[3].id)"
            class="reaction-item p-ml-2"
            pTooltip="{{ 'clubs.page.common.reactions.sad' | translate }}"
            tooltipPosition="top"
        >
            {{ reactionTypes[3].code }}
        </span>
        <span
            (click)="addReaction(reactionTypes[4].id)"
            class="reaction-item p-ml-2"
            pTooltip="{{ 'clubs.page.common.reactions.angry' | translate }}"
            tooltipPosition="top"
        >
            {{ reactionTypes[4].code }}
        </span>
    </p-card>
</div>
<div #outside></div>
